export default {
  sideBar: {
    buttons: {
      edit: 'Activer/Désactiver le mode édition',
      createView: 'Créer une vue',
      createPrivateView: 'Créer une vue privée',
    },
    loggedUsersCount: 'Sessions actives',
    ordering: {
      popups: {
        success: 'Les groupes ont été réorganisés',
        error: 'Plusieurs groupes n\'ont pas été réorganisés',
        periodicRefreshWasPausedWhileEditingGroups: 'Le rafraîchissement périodique est mis en pause pendant l\'édition du menu',
        periodicRefreshWasPaused: 'Le rafraîchissement périodique est mis en pause',
        periodicRefreshWasResumed: 'Reprise du rafraîchissement périodique',
      },
    },
  },
  topbar: {
    customObjects: 'Objets personnalisés',
  },
};
